export class OfferComparisonGroup {
    public Name: string;

    public Data: Data[]
}


export class Data {
    public CapRate : number

    public OfferPrice: number
}

export class OfferComparisonGroupData {
    public name: string;
  public color?: string;
    public data: number[][]
}


export class result {
    public Name: string;
    public Value: number
}
